import {ToggleGroup, ToggleGroupItem} from '@/components/ui/toggle-group';
import {getWeekDayOptions} from '@/utils/weekDays';

export type DaysOption = {
  value: number;
  label: string;
  shortLabel: string;
};

export type DaysInputProps = {
  value: number[];
  onChange: (value: number[]) => void;
  disabled?: boolean;
  className?: string;
};

function DaysInput({value, onChange, disabled, className}: DaysInputProps) {
  const daysOptions = getWeekDayOptions() as DaysOption[];

  return (
    <ToggleGroup
      type="multiple"
      size="small"
      value={value.map(String)}
      itemVariant="white"
      onValueChange={selectedValues => {
        const selectedDays = new Set(selectedValues.map(Number));
        onChange(
          daysOptions
            .filter(option => selectedDays.has(option.value))
            .map(option => option.value)
        );
      }}
      disabled={disabled}
      className={className}
    >
      {daysOptions.map(option => (
        <ToggleGroupItem
          key={option.value}
          value={String(option.value)}
          aria-label={option.label}
        >
          {option.shortLabel}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}

export default DaysInput;
